function SubscriptionReportData() {
  return (
    <div className="space-y-4">
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className="flex items-center justify-between p-4 bg-[#F8F9FC] rounded-lg animate-pulse"
        >
          <div className="flex items-center gap-4 flex-1">
            <div className="w-10 h-10 rounded-lg bg-gray-200 border border-gray-200" />
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-200 rounded w-32" />
              <div className="h-3 bg-gray-200 rounded w-48" />
            </div>
          </div>
          <div className="flex flex-col items-end gap-2">
            <div className="h-4 bg-gray-200 rounded w-20" />
            <div className="h-3 bg-gray-200 rounded w-12" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default SubscriptionReportData;
